import {combineReducers} from 'redux'
import {reducer as formReducer} from 'redux-form'
import {localeReducer} from 'react-localize-redux';
//import page from './page'
import user from './user'
import cards from './cards'
import formStatus from './formStatus'
import {routerReducer} from 'react-router-redux'
import {sessionReducer} from 'redux-react-session';

export default combineReducers({
    //page,
    user,
    cards,
    formStatus,
    form: formReducer,
    router: routerReducer,
    session: sessionReducer,
    locale: localeReducer
})



// WEBPACK FOOTER //
// ./src/reducers/index.js